/* eslint-disable no-useless-escape */

/**
 * Reliable method for detecting browsers, more so than checking browser userAgent
 * Source: https://stackoverflow.com/a/9851769
 */

function getIeVersion() {
  const uaString = navigator.userAgent;
  const match = /\b(MSIE |Trident.*?rv:|Edge\/)(\d+)/.exec(uaString);

  if (match) return parseInt(match[2], 10);
}

export const IS_BROWSER_IE = /* @cc_on!@ */ false || !!document.documentMode;
export const IS_BROWSER_IE_10_AND_BELOW = getIeVersion() < 11;

// Opera 8.0+
export const IS_BROWSER_OPERA =
  (window && (!!window.opera || (!!window.opr && !!window.opr.addons))) ||
  navigator.userAgent.indexOf(' OPR/') >= 0 ||
  navigator.userAgent.indexOf('Opera') >= 0;

// Firefox 1.0+
export const IS_BROWSER_FIREFOX = typeof InstallTrigger !== 'undefined';

// Edge 20+
export const IS_BROWSER_EDGE = !IS_BROWSER_IE && !!window.StyleMedia;

// Chrome 1 - 71
export const IS_BROWSER_CHROME =
  ((window &&
    !!window.chrome &&
    /Google Inc/.test(navigator.vendor) &&
    !window.opera &&
    !navigator.userAgent.match(/SamsungBrowser/i)) ||
    navigator.userAgent.match('CriOS')) &&
  !IS_BROWSER_OPERA;

// Safari 3.0+
export const IS_BROWSER_SAFARI =
  /constructor/i.test(window.HTMLElement) ||
  (p => {
    return p.toString() === '[object SafariRemoteNotification]';
  })(
    !window.safari ||
      (typeof safari !== 'undefined' && window.safari.pushNotification)
  ) ||
  (!!window.navigator.userAgent.match(/WebKit/i) &&
    !window.navigator.userAgent.match(/CriOS/i));

export const IS_IOS = navigator.userAgent.match(/iPhone|iPod|iPad/i);

export const IS_ANDROID = navigator.userAgent.match(/Android/i);

/** https://stackoverflow.com/a/3540295 */

export const IS_MOBILE_DEVICE =
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
    navigator.userAgent
  ) ||
  /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    navigator.userAgent.substr(0, 4)
  );

// export const IS_IOS_OR_ANDROID =
//   navigator.userAgent.match(/Android/i) ||
//   navigator.userAgent.match(/iPhone|iPod/i);

/**
 * Returns boolean if device is detected to be able to trigger touch events (all mobile and tablet devices)
 *
 * @returns {boolean}
 */
export const isTouchDevice = () =>
  'ontouchstart' in window ||
  navigator.MaxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;

export const isMobileKeyboardOpen = () => {
  /** If the difference between the screen height and window height is > 200px, we can
   * assume its an open mobile keyboard taking up that space. This currently only applies
   * for Android, as iOS doesn't resize the window when the keyboard opens like Android
   * does.  */
  return window.screen.height - window.innerHeight > 200 && isTouchDevice();
};

/** Used some ideas from this: https://stackoverflow.com/a/38241481 */
export function getDeviceTypeForTracking() {
  const { platform } = window.navigator;
  const macPlatforms = ['Mac', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win', 'Win32', 'Win64', 'Windows', 'WinCE'];

  if (platform === 'iPhone' || IS_IOS) {
    return 'iPhone';
  }
  if (platform === 'iPad') {
    return 'iPad';
  }
  if (IS_ANDROID) {
    return 'Android';
  }
  if (IS_MOBILE_DEVICE) {
    return 'Other Mobile';
  }
  if (macPlatforms.includes(platform)) {
    return 'Mac';
  }
  if (windowsPlatforms.includes(platform)) {
    return 'Windows';
  }
  return 'Other Desktop';
}

export function getBrowserForTracking() {
  if (IS_BROWSER_CHROME) {
    return 'Chrome';
  }
  if (IS_BROWSER_FIREFOX) {
    return 'Firefox';
  }
  if (IS_BROWSER_IE) {
    return 'Internet Explorer';
  }
  if (IS_BROWSER_EDGE) {
    return 'Edge';
  }
  if (IS_BROWSER_OPERA) {
    return 'Opera';
  }
  if (IS_BROWSER_SAFARI) {
    return 'Safari';
  }
  return 'Other Browser';
}
